/**
 * Table Status
 * 'Viewied status' icon used for records
 */
import React from 'react';

import Status from '@components/Status';

export const TableStatus: React.FC<{ value: boolean }> = ({
  value = false,
}) => {
  if (value) {
    return null;
  }

  return <Status variant="blue" />;
};
